import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { useMemo, useState } from 'react';
import { LTModal } from '@lambdatestincprivate/lt-components';
import { KeyValueTable } from './KeyValueTable';
import styles from './steps.module.css';

/**
 * View-mode replica of kaneai's ApiFlowModal, matched against the PROD
 * summary-page modal (960×~610, padding-0 dialog): "Create an API call"
 * header, [method ▾][url][Timeout chip] row, request tabs (Params /
 * Authorization / Headers / Body / Settings) over a Key/Value table with
 * placeholder empty rows, a bottom Response ACCORDION (collapsed by
 * default; expands to status pill + time + Body/Cookies/Headers), and
 * the "You are in view only mode" footer. The real modal's edit
 * affordances (method dropdown, Bulk Edit, Validate) are inert here —
 * pack data is sealed.
 */
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var REQUEST_TABS = ['Params', 'Authorization', 'Headers', 'Body', 'Settings'];
var RESPONSE_TABS = ['Body', 'Cookies', 'Headers'];

/** kaneai ApiFlowResponse getStatusColor, verbatim. */
function statusColor(status) {
  if (status >= 200 && status < 300) return {
    fg: '#197935',
    bg: '#DAFBE1'
  };
  if (status >= 300 && status < 400) return {
    fg: '#0969DA',
    bg: '#DDF4FF'
  };
  if (status >= 400) return {
    fg: '#D73A49',
    bg: '#FEE2E2'
  };
  return {
    fg: '#59636e',
    bg: '#F0F0F0'
  };
}

/** kaneai ApiFlowResponse formatTime, verbatim. */
function formatTime(time) {
  if (!time) return '';
  if (time < 1000) return "".concat(time.toFixed(), " ms");
  return "".concat((time / 1000).toFixed(2), " s");
}
var STATUS_MESSAGES = {
  200: 'OK',
  201: 'Created',
  204: 'No Content',
  301: 'Moved Permanently',
  302: 'Found',
  304: 'Not Modified',
  400: 'Bad Request',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'Not Found',
  405: 'Method Not Allowed',
  408: 'Request Timeout',
  429: 'Too Many Requests',
  500: 'Internal Server Error',
  502: 'Bad Gateway',
  503: 'Service Unavailable',
  504: 'Gateway Timeout'
};
function isRecord(v) {
  return v !== null && _typeof(v) === 'object' && !Array.isArray(v);
}

/** Headers arrive as a record OR an array of single-key records (the
 * pack's response.headers shape) — normalize to entries. */
function toEntries(v) {
  var out = [];
  var push = function push(rec) {
    for (var _i = 0, _Object$entries = Object.entries(rec); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        k = _Object$entries$_i[0],
        val = _Object$entries$_i[1];
      out.push([k, typeof val === 'string' ? val : JSON.stringify(val)]);
    }
  };
  if (Array.isArray(v)) {
    var _iterator = _createForOfIteratorHelper(v),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        if (isRecord(item)) push(item);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  } else if (isRecord(v)) {
    push(v);
  }
  return out;
}
function pretty(v) {
  if (v === undefined || v === null || v === '') return '';
  if (typeof v === 'string') {
    try {
      return JSON.stringify(JSON.parse(v), null, 2);
    } catch (_unused) {
      return v;
    }
  }
  var text = JSON.stringify(v, null, 2);
  return text === '{}' || text === '[]' ? '' : text;
}
var Chevron = function Chevron(_ref) {
  var open = _ref.open;
  return /*#__PURE__*/_jsx("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    style: {
      transform: open ? 'rotate(90deg)' : undefined,
      transition: 'transform 0.15s'
    },
    children: /*#__PURE__*/_jsx("path", {
      d: "M6 3.5 11 8l-5 4.5",
      stroke: "#59636E",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};
var KvTable = function KvTable(_ref2) {
  var entries = _ref2.entries;
  return /*#__PURE__*/_jsx(KeyValueTable, {
    rows: entries.map(function (_ref3, i) {
      var _ref4 = _slicedToArray(_ref3, 2),
        k = _ref4[0],
        v = _ref4[1];
      return {
        id: "".concat(k, "-").concat(i),
        name: k,
        value: v
      };
    })
  });
};
var JsonPane = function JsonPane(_ref5) {
  var value = _ref5.value,
    empty = _ref5.empty;
  var text = pretty(value);
  return text === '' ? /*#__PURE__*/_jsx("div", {
    className: styles.apiModalEmpty,
    children: empty
  }) : /*#__PURE__*/_jsx("pre", {
    className: styles.apiModalJson,
    children: text
  });
};
function TabBar(_ref6) {
  var tabs = _ref6.tabs,
    active = _ref6.active,
    onSelect = _ref6.onSelect;
  return /*#__PURE__*/_jsx("div", {
    className: styles.apiModalTabs,
    role: "tablist",
    children: tabs.map(function (t) {
      return /*#__PURE__*/_jsx("button", {
        type: "button",
        role: "tab",
        "aria-selected": t === active,
        className: "".concat(styles.apiModalTab, " ").concat(t === active ? styles.apiModalTabActive : ''),
        onClick: function onClick() {
          return onSelect(t);
        },
        children: t
      }, t);
    })
  });
}
export function ApiModal(_ref7) {
  var _api$request, _api$response, _STATUS_MESSAGES$stat, _api$url;
  var api = _ref7.api,
    onClose = _ref7.onClose;
  var _useState = useState('Params'),
    _useState2 = _slicedToArray(_useState, 2),
    reqTab = _useState2[0],
    setReqTab = _useState2[1];
  var _useState3 = useState('Body'),
    _useState4 = _slicedToArray(_useState3, 2),
    resTab = _useState4[0],
    setResTab = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    resOpen = _useState6[0],
    setResOpen = _useState6[1];
  var req = (_api$request = api.request) !== null && _api$request !== void 0 ? _api$request : {};
  var res = (_api$response = api.response) !== null && _api$response !== void 0 ? _api$response : {};
  var status = api.responseStatus;
  var colors = status !== null ? statusColor(status) : null;
  var statusMsg = status !== null ? (_STATUS_MESSAGES$stat = STATUS_MESSAGES[status]) !== null && _STATUS_MESSAGES$stat !== void 0 ? _STATUS_MESSAGES$stat : '' : '';
  var timeout = typeof req.timeout === 'number' ? req.timeout : null;
  var settings = useMemo(function () {
    var rows = [];
    for (var _i2 = 0, _Object$entries2 = Object.entries(req); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        k = _Object$entries2$_i[0],
        v = _Object$entries2$_i[1];
      if (['method', 'url', 'headers', 'params', 'authorization', 'body', 'timeout'].includes(k)) {
        continue;
      }
      rows.push([k, typeof v === 'string' ? v : JSON.stringify(v)]);
    }
    return rows;
  }, [req]);
  return /*#__PURE__*/_jsx(LTModal, {
    isOpen: true,
    ariaLabel: "Create an API call",
    onClose: onClose,
    extraStyle: {
      width: '960px',
      maxWidth: '92vw',
      // Short viewports: the dialog must never outgrow the screen —
      // the body scrolls internally instead (QA repro at low heights).
      maxHeight: '86vh',
      // Tall content must not stretch the dialog past the cap; the
      // roomy default comes from minHeight instead.
      minHeight: 'min(560px, 86vh)',
      overflow: 'hidden',
      fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Noto Sans', Helvetica, Arial, sans-serif"
    },
    customHeaderComponent: /*#__PURE__*/_jsx("div", {
      style: {
        flex: 1,
        textAlign: 'left'
      },
      children: /*#__PURE__*/_jsx("span", {
        style: {
          fontSize: '14px',
          fontWeight: 600,
          lineHeight: '20px',
          letterSpacing: '-0.15px'
        },
        children: "Create an API call"
      })
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.apiModalBody,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.apiModalUrlRow,
        children: [/*#__PURE__*/_jsxs("span", {
          className: styles.apiModalMethod,
          children: [api.method, /*#__PURE__*/_jsx("svg", {
            width: "10",
            height: "10",
            viewBox: "0 0 16 16",
            fill: "none",
            "aria-hidden": "true",
            children: /*#__PURE__*/_jsx("path", {
              d: "M3.5 6 8 10.5 12.5 6",
              stroke: "#59636E",
              strokeWidth: "1.5",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            })
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: styles.apiModalUrlInput,
          children: (_api$url = api.url) !== null && _api$url !== void 0 ? _api$url : ''
        }), timeout !== null && /*#__PURE__*/_jsxs("span", {
          className: styles.apiModalTimeout,
          children: ["Timeout: ", timeout, "ms"]
        })]
      }), /*#__PURE__*/_jsx(TabBar, {
        tabs: REQUEST_TABS,
        active: reqTab,
        onSelect: setReqTab
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.apiModalPane,
        children: [reqTab === 'Params' && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.apiModalPaneTitle,
            children: "Query Params"
          }), /*#__PURE__*/_jsx(KvTable, {
            entries: toEntries(req.params)
          })]
        }), reqTab === 'Authorization' && /*#__PURE__*/_jsx(JsonPane, {
          value: req.authorization,
          empty: "No authorization"
        }), reqTab === 'Headers' && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.apiModalPaneTitle,
            children: "Headers"
          }), /*#__PURE__*/_jsx(KvTable, {
            entries: toEntries(req.headers)
          })]
        }), reqTab === 'Body' && /*#__PURE__*/_jsx(JsonPane, {
          value: req.body,
          empty: "No body"
        }), reqTab === 'Settings' && /*#__PURE__*/_jsx(KvTable, {
          entries: settings
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.apiModalResAccordion,
        children: [/*#__PURE__*/_jsxs("button", {
          type: "button",
          className: styles.apiModalResRow,
          "aria-expanded": resOpen,
          onClick: function onClick() {
            return setResOpen(function (v) {
              return !v;
            });
          },
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.apiModalResTitle,
            children: "Response"
          }), /*#__PURE__*/_jsxs("span", {
            className: styles.apiModalResMeta,
            children: [status !== null && colors && /*#__PURE__*/_jsxs("span", {
              className: styles.apiModalStatusPill,
              style: {
                color: colors.fg,
                background: colors.bg
              },
              children: [status, statusMsg ? " ".concat(statusMsg) : '']
            }), formatTime(api.responseTimeMs) && /*#__PURE__*/_jsx("span", {
              className: styles.apiModalTime,
              children: formatTime(api.responseTimeMs)
            }), /*#__PURE__*/_jsx(Chevron, {
              open: resOpen
            })]
          })]
        }), resOpen && /*#__PURE__*/_jsxs("div", {
          className: styles.apiModalResBody,
          children: [/*#__PURE__*/_jsx(TabBar, {
            tabs: RESPONSE_TABS,
            active: resTab,
            onSelect: setResTab
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.apiModalPane,
            children: [resTab === 'Body' && /*#__PURE__*/_jsx(JsonPane, {
              value: res.response_body,
              empty: "No response body"
            }), resTab === 'Cookies' && /*#__PURE__*/_jsx(KvTable, {
              entries: toEntries(res.cookies)
            }), resTab === 'Headers' && /*#__PURE__*/_jsx(KvTable, {
              entries: toEntries(res.headers)
            })]
          })]
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.apiModalFooter,
        children: "You are in view only mode"
      })]
    })
  });
}